var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card-body',[(_vm.ShowTitle)?_c('b-card-title',{staticClass:"font-weight-semibold"},[_vm._v(" "+_vm._s(_vm.News.Title)+" ")]):_vm._e(),_c('b-card-text',{domProps:{"innerHTML":_vm._s(_vm.News.Message)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }